import 'arrive'
import { gsap } from 'gsap'
import gallery_modal from './_gallery';

document.arrive('.btn-modal', {existing: true}, function() {

  const button = this;
  const modals = document.querySelectorAll('.modal-js');
  const generateDivider = (open, close, label) => {
    return '<div class="divider"><button data-open="' + open + '" data-close="' + close +'" data-alertmodal="info" data-noscroll="true" class="btn-toggle">' +
        '<span class="label">' + label + '</span></button></div>';
  }

  const wrapExpandableSection = (content, paragraphs = 1, divider = '') => {
    const prefix = '<div data-visible="' + paragraphs + '" class="text-toggle"><div class="inner">';
    const suffix = '</div>';

    let parts = content.split('<br />');
    let finalContent = '';

    parts.forEach((part) => {
      if(part === '') {
        finalContent += finalContent !== '' ? '' : '<br />'
      }
      else {
        finalContent += finalContent === '' ? '<p>' : '</p><p>';
        finalContent += part;
      }
    });

    finalContent += '</p>';

    return prefix + finalContent + suffix + divider + suffix;
  }

  button.onclick = function() {

    modals.forEach( modal => {

      const name = modal.dataset.name;

      if ( this.dataset.modal == name ) {

        if ( name == 'info' ) {

          const title = modal.querySelector('.title');
          const content = modal.querySelector('.excerpt');
          const image = modal.querySelector('.picture');


          title.innerHTML = content.innerHTML = image.innerHTML = '';


          if(this.dataset.expandable == '1') {
            modal.classList.add('expandable');
            modal.classList.remove('expanded');
            content.innerHTML = wrapExpandableSection(this.dataset.content,  this.dataset.paragraphs, generateDivider(this.dataset.open, this.dataset.close, this.dataset.label));
          }
          else {
            modal.classList.remove('expandable');
            content.innerHTML = this.dataset.content;
          }

          if ( !this.dataset.title ) title.style.display = 'none';
          else title.style.display = 'block';

          title.innerHTML = this.dataset.title || "No title";

          if (this.dataset.icon) {

            image.innerHTML = '<div class="icon"><img src="' + this.dataset.icon + '" alt="' + this.dataset.iconalt + '"/></div>';

          } else if (this.dataset.logo) {

            image.innerHTML = '<div class="logo"><img src="' + this.dataset.logo + '" alt="' + this.dataset.logoalt + '"/></div>';

          }

        }

        modal.classList.add('show');
        console.log(modal.querySelector('.btn-close'));

        gsap.to(modal, {

          autoAlpha: 1,
          ease: 'linear',
          duration: 0.3

        });

        if ( name == 'gallery' || name == 'search' || name == 'info') {

          const height = modal.clientHeight;

          document.getElementsByTagName("html")[0].style.overflow = 'hidden';

        }

        if ( name.startsWith('gallery')) {
          gallery_modal(modal);
        }

        setTimeout(() => {
          modal.querySelector('.btn-close').focus({ focusVisible: true });
        }, 301);
      }

    });
  }

});

document.arrive('.modal-js', {existing: true}, function() {

  const modal = this;

  modal.addEventListener('click',function(e) {

    const target = e.target;
    const name = modal.dataset.name;

    if ( target.classList.contains('modal-js') && name != 'search' ) {

      if ( name == 'gallery' || name == 'search' || name == 'info' ) {

        document.getElementsByTagName("html")[0].style.overflow = '';
  
      }

      gsap.to(modal, {

        autoAlpha: 0,
        ease: 'linear',
        duration: 0.3,

        onComplete: () => {
          modal.classList.remove('show');
        }

      });

    }

  });

});

document.arrive('.btn-close', {existing: true}, function() {

  const button = this;
  const modal = button.closest('.modal-js');

  button.onclick = function() {

    const name = modal.dataset.name;

    if ( name == 'gallery' || name == 'search' || name == 'info' ) {

      document.getElementsByTagName("html")[0].style.overflow = '';

    }

    modal.classList.remove('expanded');
    gsap.to(modal, {

      autoAlpha: 0,
      ease: 'linear',
      duration: 0.3,

      onComplete: () => {
        modal.classList.remove('show');
      }

    });

  }

});

(function() {
  window.addEventListener('keydown', closeMenuWithEsc);
  window.addEventListener('keydown', closeSearchWithEsc);
  window.addEventListener('keydown', closeModalsWithEsc);
})();

function closeMenuWithEsc(e) {
  if (e.key === 'Escape') {
    let menu = document.getElementById("navbar-opener");
    if (!menu) return;
    if(menu.classList.contains('opened')) {
      menu.click();
    }
  }
}

function closeSearchWithEsc(e) {
  if (e.key === 'Escape') {
    let search = document.getElementsByClassName("modal-search")[0];
    if (!search) return;
    if(search.classList.contains('show')) {
      search.querySelector('.btn-close').click();
    }
  }
}


function closeModalsWithEsc(e) {
  if (e.key === 'Escape') {
    let modal = document.getElementsByClassName("modal-info")[0];
    if (!modal) return;
    if(modal.classList.contains('show')) {
      modal.querySelector('.btn-close').click();
    }
  }
}